import { Controller } from 'stimulus'
import * as Loadash from 'lodash'
import { useDebounce } from 'stimulus-use'

export default class extends Controller {
  static targets = ['form', 'toggleableContainer']
  static classes = ['showContainer']

  static values = {
    formData: Object,
    cached: Boolean
  }

  static debounces = ['toggleContainerIfFormDataChanged']

  initialize() {
    useDebounce(this)
    if (!this.cachedValue) {
      this.refreshformData()
    } else {
      location.reload()
    }
  }

  connect() {
    this.toggleContainerIfFormDataChanged()
  }

  disconnect() {
    this.cachedValue = true
  }

  formDataValueChanged() {
    this.toggleContainerIfFormDataChanged()
  }

  toggleContainerIfFormDataChanged() {
    setTimeout(() => {
      if (this.hasFormDataChanged) {
        this.toggleableContainerTarget.classList.add(this.showContainerClass)
      } else {
        this.toggleableContainerTarget.classList.remove(this.showContainerClass)
      }
    }, 0)
  }

  refreshFormData() {
    this.formDataValue = this.formValuesHash(this.formTarget)
  }

  // PRIVATE
  formValuesHash(form) {
    const data = new FormData(form)
    const hash = {}
    const nameIsFromArray = (name) => {
      if (name.length < 2) {
        return false
      }
      return name[name.length - 1] === ']' && name[name.length - 2] === '['
    }
    for (const pair of data.entries()) {
      const key = pair[0]
      const val = pair[1]
      if (nameIsFromArray(key) && key in hash) {
        if (!Array.isArray(hash[key])) {
          const temp = hash[key]
          hash[key] = []
          hash[key].push(temp)
        }

        hash[key].push(val)
      } else {
        hash[key] = val
      }
    }
    return hash
  }

  get hasFormDataChanged() {
    return !Loadash.isEqual(this.formDataValue, this.formValuesHash(this.formTarget))
  }
}
